<template>
  <AtomsCalculatorFrame
    iframe-class="!mx-auto"
    :type="type"
    :src="src"
  />
</template>

<script>
export default {
  name: 'MoleculesCalculatorBorrowingPower',

  data: () => ({
    type: 'Borrowing_Power_Calculator',
    src: '//www.visionabacus.net/Tools/B3/SuiteA/A200/Borrowing_Power_Calculator/CompareClub'
  })
}
</script>
